import LegalPage from "./LegalPage";
const Cookies = () => <LegalPage docKey="cookies" />;
export default Cookies;
